<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
     <div class="text-xs-center hidden-sm-and-down">
        <svg-buttons @finished="$store.commit('nextShow', true)"/>
    </div>
    <v-layout wrap align-center class="hidden-md-and-up">
      <v-flex xs12>
        <button class="hover hvr-color black--text py-2 px-3 ma-1" @click="actual=1, $set(vistos,0,true)">Exploración</button>
        <button class="hover hvr-color black--text py-2 px-3 ma-1" @click="actual=2, $set(vistos,1,true)">Descubrimiento</button>
        <button class="hover hvr-color black--text py-2 px-3 ma-1" @click="actual=3, $set(vistos,2,true)">Delineación</button>
        <button class="hover hvr-color black--text py-2 px-3 ma-1" @click="actual=4, $set(vistos,3,true)">Comercialidad</button>
        <button class="hover hvr-color black--text py-2 px-3 ma-1" @click="actual=5, $set(vistos,4,true)">Reservas</button>
        <button class="hover hvr-color black--text py-2 px-3 ma-1" @click="actual=6, $set(vistos,5,true)">Producción</button>
        <button class="hover hvr-color black--text py-2 px-3 ma-1" @click="actual=7, $set(vistos,6,true)">Abandono</button>
        <button class="hover hvr-color black--text py-2 px-3 ma-1" @click="actual=8, $set(vistos,7,true)">Recuperación primaria</button>
        <button class="hover hvr-color black--text py-2 px-3 ma-1" @click="actual=9, $set(vistos,8,true)">Recuperación secundaria y terciaria</button>
      </v-flex>
      <v-flex xs12>
        <p v-if="actual == 1" class="texto1"><strong>Exploración:</strong> Una vez se inicia la etapa de exploración se generan recursos prospectivos que son cantidades de petróleo estimadas a una fecha determinada potencialmente recuperable de acumulaciones no descubiertas.</p>
        <p v-if="actual == 2" class="texto1"><strong>Descubrimiento:</strong> Después se genera el descubrimiento que es la cantidad significativa de hidrocarburos potencialmente movibles a través de pruebas muestreos y registros.</p>
        <p v-if="actual == 3" class="texto1"><strong>Delineación:</strong> En la etapa de delineación del yacimiento se generan los recursos contingentes que son cantidades de petróleo recuperables estimadas a una fecha determinada de acumulaciones conocidas, pero donde el desarrollo comercial no está lo suficientemente maduro.</p>
        <p v-if="actual == 4" class="texto1"><strong>Comercialidad:</strong> cuando se superan los criterios económicos del evaluador y no hay contingencias que impidan el desarrollo, se cumple con el criterio de comercialidad.</p>
        <p v-if="actual == 5" class="texto1"><strong>Reservas:</strong>  inicia la etapa de estimación de reservas, las cuales son extraídas inicialmente a través de la recuperación primaria; es decir, con la aplicación de mecanismos naturales de producción en el yacimiento y así entrar en la etapa inicial de producción.</p>
        <p v-if="actual == 6" class="texto1"><strong>Producción:</strong> luego de agotarse los mecanismos naturales de producción del yacimiento, se aplican métodos de recuperación secundaria y terciaria para la extracción de los volúmenes remanentes de reservas, o se generan recursos contingentes si los métodos no son económicamente rentables.</p>
        <p v-if="actual == 7" class="texto1"><strong>Abandono:</strong> finalmente, luego de agotar todos los recursos, la última fase del yacimiento es el abandono.</p>
        <p v-if="actual == 8" class="texto1"><strong>Recuperación primaria:</strong> Se trata de la aplicación de mecanismos naturales de producción en el yacimiento.</p>
        <p v-if="actual == 9" class="texto1"><strong>Recuperación secundaria y terciaria:</strong> Se aplican métodos de extracción secundaria y terciara, al agotarse los mecanismos naturales de producción.</p>
      </v-flex>
    </v-layout>
    
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
      'Modulo 3/AUDIO 10'
    ]"></audio-player> 
  </div>
</template>

<script>
import SvgButtons from '../../assets/Modulo 3/diapositiva-10'
export default {
  components:{
    SvgButtons
  },
  data() {
    return {
      dialogos: [
        "Los métodos de estimación de reservas pueden ser aplicados según la vida del yacimiento, de la siguiente manera: <span class='instruccion'>Haz clic en cada estación del esquema</span>" 
      ],
      actual: 0,
      vistos: Array(7).fill(false)
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  watch: {
    vistos: function(newValue){
      var todosVistos = newValue.every(el => {return el})
      if(todosVistos) {
        this.$store.commit('nextShow', true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
